import React from 'react';
import { withRouter } from 'react-router-dom';
import Builder from '../workouts/Builder';
import NavigationTabs from '../nav/NavigationTabs'
import FormContent from './FormContent';
import { AlertJsMessage } from './../../helpers.js'

class Form extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      expand: 1,
      sequence: {},
      dataLoaded: false,
      edit: null,
      submitAction: 'create',
      formData: {
        name: '',
        categoryId: ''
      },
      sequenceData: {

      }
    };
  }

  componentDidMount() {
    this.props.fetchBlockFormValues().then(() => {
      const { editId } = this.props;
      if (editId) {
        this.props.fetchBlock(editId).then(() => {
          const { blocks, blockInfo } = this.props;
          if (Object.keys(blockInfo).length > 0) {
            this.setState({
              ...this.state,
              submitAction: 'edit',
              dataLoaded: true,
              editBlock: blockInfo,
              formData: {
                ...this.state.formData,
                categoryId: blockInfo.categoryId,
                name: blockInfo.name,
              }
            })
          } else {
            console.error("Error when loading block with edit id of " + editId);
          }
        });
      } else {
        this.setState({
          ...this.state,
          submitAction: 'create',
          dataLoaded: true
        })
      }
    });
  }

  componentWillUnmount() {
    this.props.resetExercises();
    this.props.resetExerciseFilter();
  }

  handleExpand(step) {
    this.setState(state => ({ expand: state.expand === 1 ? 2 : 1 }));
  }
  handleChange = field => event => {
    this.setState({
      ...this.state,
      formData: {
        ...this.state.formData,
        [field]: event.target.value
      }
    })
  }

  handlePriceRadio = field => event => {
    if (event.target.value === '1') {
      this.setState({
        ...this.state,
        showPricingInput: true
      })
    } else {
      this.setState({
        ...this.state,
        formData: {
          ...this.state.formData,
          pricing: 0
        },
        showPricingInput: false
      })
    }
  }

  
  submitForm() {
    const { selected } = this.builder.state;
    const required = [
      'name',
      'categoryId'
    ];
    for (var i = 0; i < required.length; i++) {
      if (!this.state.formData[required[i]]) {
        AlertJsMessage(required[i] + ' is required.');
        return;
      }
    }
    // validate at least one exercise is selected.
    if (!selected.length) {
      AlertJsMessage('Please add an exercise before continuing.');
      return;
    }
    if (this.state.submitAction === 'create') {
      this.props.create('block', this.state.formData, selected).then((data) => {
        this.props.updateDuration(data.data._id, 'ByBlock').then((res) => {
          this.props.history.push(`/blocks/${data.data._id}?new=true`);
        });
      });
    } else if (this.state.submitAction === 'edit') {
      this.props.edit('block', { ...this.state.formData, id: this.props.editId }, selected).then((data) => {
        this.props.updateDuration(this.props.editId, 'ByBlock').then((res) => {
          this.props.history.push(`/blocks/${this.props.editId}`);
        });
      });
    }
  }

  onCancel = () => {
    if (this.props.editId) {
      this.setState({
        expand: 0,
      });
      return;
    } else {
      this.setState({
        expand: 0,
        formData: {
          name: '',
          categoryId: ''
        }
      });
      return;
    }
  }

  render() {
    const { expand, formData, dataLoaded, editBlock, submitAction } = this.state;
    const { editId, blockCats, trainerExercises, corporateExercises, equipment, favExercises, exerciseCats, user } = this.props;
    return (
      <div>
        {
          this.props.hideNavigationTabs ? null : (
            <NavigationTabs
              title={editId ? `Edit ${formData.name}` : 'Build'}
              subtitle="Blocks"
              description="Create warm ups, cooldowns, circuits, finishers, or any other group of exercises you commonly use in your practice.  Blocks will help save you time when you build workouts."
              set="build"
              activeRoute="/build/block" />
          )
        }
        {dataLoaded &&
          <FormContent
            formData={formData}
            expand={expand}
            expansionChange={(step) => this.handleExpand(step)}
            formChange={(field) => this.handleChange(field)}
            submitAction={submitAction}
            onCancel={this.onCancel}
            blockCats={blockCats}
            Builder={(
              <Builder
                editWorkout={editBlock}
                type="block"
                ref={(ref) => { this.builder = ref }}
                trainerExercises={trainerExercises}
                corporateExercises={corporateExercises}
                equipment={equipment}
                categories={exerciseCats}
                favExercises = {favExercises}
                sequence={this.state.sequence}
                workoutFormData={this.state.formData}
                validateForm={() => this.submitForm()}
                onCancel={this.onCancel}
                user={user}
                blockCats={blockCats}
                blocks={this.props.blocks}
                fetchMoreExercise = {this.props.fetchMoreExercise}
                fetchMoreBlock = {this.props.fetchMoreBlock}
                resetExercises= {this.props.resetExercises}
                resetBlocks = {this.props.resetBlocks}
                resetExerciseFilter = {this.props.resetExerciseFilter}
                exerciseStoreFilter = {this.props.filter}
                setExerciseFilter = {this.props.setExerciseFilter}
                setExerciseSearchTerm = {this.props.setExerciseSearchTerm}
                isLoadMoreLibraryExercises = {this.props.isLoadMoreLibraryExercises}
                isLoadMoreLibraryBlocks = {this.props.isLoadMoreLibraryBlocks}
                toggleExerciseFavourite = {this.props.toggleExerciseFavourite}
                searchTerm = {this.props.searchTerm}
                saveExerciseStatus = {() => {}}
              />
            )}
          />
        }
      </div>
    );
  }
}

export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/components/blocks/Form.js